import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { blogById, getActiveBlogCategory, salaryTypeById, updateBlog, updateSalaryType } from '../../../actions/utilitiesAction'
import Add from '../../../component/Utilities/Blog/AddBlog'
import constant from '../../../constant'
const EditBlog = () => {
    const [response, setResponse] = React.useState({})
    const [showMsg, setShowMsg] = React.useState(false)

    const navigate = useNavigate()
    const params = useParams()
    const [data, setData] = useState(null)
    const [list, setList] = useState([])

    useEffect(() => {

        blogById(parseInt(params.id)).then((res) => {
            if (res.status) {
                setData(res.result)
            }
            else {
                setResponse(res)
                setShowMsg(true)
                setTimeout(() => {
                    setShowMsg(false)
                }, 7000)
            }
        }).catch(err => {
            alert(err)
        })

        getActiveBlogCategory().then((res) => {
            setList(res.result)
        }).catch((err) => {
            alert(err)
        })
    }, [])

    const onSubmit = (model) => {
        updateBlog(model).then((res) => {
            if (res.status) {
                navigate(constant.component.bloglist.url)
            } else {
                setResponse(res)
                setShowMsg(true)
                setTimeout(() => {
                    setShowMsg(false)
                }, 7000)
            }
        }).catch((err) => {
            alert(err)
        })
    }

    return (
        <React.Fragment>
            {data && <Add onSubmit={onSubmit} detail={data} response={response} showMsg={showMsg} list={list} />}
        </React.Fragment>
    )
}
export default EditBlog;